import {
  getCurrentInstance,
  reactive,
  toRefs,
  watch,
} from 'vue'
import router from '@/router'

export const useRouter = () => {
  const instance = getCurrentInstance()
  const vm = instance?.proxy ?? instance

  if (vm) {
    const state = reactive({
      route: vm.$route,
    })

    watch(
      () => vm.$route,
      r => {
        state.route = r
      },
    )

    return { ...toRefs(state), router: vm.$router }
  }

  const state = reactive({
    route: router.currentRoute,
  })

  router.afterEach(to => {
    state.route = to
  })

  return { ...toRefs(state), router }
}

export const _ = null
